import { apiGetAuth } from '@/utils/api'
import { API_SOURCE_SCOPE, API_CORE } from '@/utils/api-url'

const state = {
  corporate_legal_list: { data: [] },
  investment_type_list: { data: [] },
  service_type_list: { data: [] },
  status_martial_list: { data: [] },
  national_entity_list: { data: [] },
  source_income_list: { data: [] },
  benefit_relation_list: { data: [] },
  source_fund_list: { data: [] },
  contribution_type_list: { data: [] },
  payment_method_program_list: { data: [] },
  frequency_payment_list: { data: [] },
  period_payment_list: { data: [] },
  investment_allocation_list: {
    isLoading: false,
    data: []
  },
  source_fund_company_list: { data: [] },
  asset_company_list: { data: [] },
  basic_calculation_management_investment_list: { data: [] },
  claim_type_list: {
    isLoading: false,
    data: []
  },
  relation_application_claim_list: { data: [] },
  disbursement_category_list: { data: [] },
  disbursement_anuitas_list: { data: [] },
  employee_position_list: { data: [] },
  diffrent_handling_list: { data: [] }
}

const mutations = {
  "SET_CORPORATE_LEGAL_LIST": (state, payload) => {
    state.corporate_legal_list = payload
  },
  "SET_INVESTMENT_TYPE_LIST": (state, payload) => {
    state.investment_type_list = payload
  },
  "SET_SERVICE_TYPE_LIST": (state, payload) => {
    state.service_type_list = payload
  },
  "SET_STATUS_MARTIAL_LIST": (state, payload) => {
    state.status_martial_list = payload
  },
  "SET_NATIONAL_ENTITY_LIST": (state, payload) => {
    state.national_entity_list = payload
  },
  "SET_SOURCE_INCOME_LIST": (state, payload) => {
    state.source_income_list = payload
  },
  "SET_BENEFIT_RELATION_LIST": (state, payload) => {
    state.benefit_relation_list = payload
  },
  "SET_SOURCE_FUND_LIST": (state, payload) => {
    state.source_fund_list = payload
  },
  "SET_CONTRIBUTION_TYPE_LIST": (state, payload) => {
    state.contribution_type_list = payload
  },
  "SET_PAYMENT_METHOD_PROGRAM_LIST": (state, payload) => {
    state.payment_method_program_list = payload
  },
  "SET_FREQUENCY_PAYMENT_LIST": (state, payload) => {
    state.frequency_payment_list = payload
  },
  "SET_PERIOD_PAYMENT_LIST": (state, payload) => {
    state.period_payment_list = payload
  },
  "SET_INVESTMENT_ALLOCATION_LIST": (state, payload) => {
    state.investment_allocation_list = payload
  },
  "SET_SOURCE_FUND_COMPANY_LIST": (state, payload) => {
    state.source_fund_company_list = payload
  },
  "SET_ASSET_COMPANY_LIST": (state, payload) => {
    state.asset_company_list = payload
  },
  "SET_BASIC_CALCULATION_MANAGEMENT_INVESTMENT_LIST": (state, payload) => {
    state.basic_calculation_management_investment_list = payload
  },
  "SET_CLAIM_TYPE_LIST": (state, payload) => {
    state.claim_type_list = payload
  },
  "SET_RELATION_APPLICATION_CLAIM_LIST": (state, payload) => {
    state.relation_application_claim_list = payload
  },
  "SET_DISBURSEMENT_CATEGORY_LIST": (state, payload) => {
    state.disbursement_category_list = payload
  },
  "SET_DISBURSEMENT_ANUITAS_LIST": (state, payload) => {
    state.disbursement_anuitas_list = payload
  },
  "SET_EMPLOYEE_POSITION_LIST": (state, payload) => {
    state.employee_position_list = payload
  },
  "SET_DIFFRENT_HANDLING_LIST": (state, payload) => {
    state.diffrent_handling_list = payload
  }
}

const SOURCE_SCOPE_NAME_TO_MUTATION = {
  'jenis badan hukum': 'SET_CORPORATE_LEGAL_LIST',
  'jenis investasi': 'SET_INVESTMENT_TYPE_LIST',
  'jenis layanan': 'SET_SERVICE_TYPE_LIST',
  'status karyawan': 'SET_STATUS_MARTIAL_LIST',
  'kewarganegaraan': 'SET_NATIONAL_ENTITY_LIST',
  'sumber penghasilan': 'SET_SOURCE_INCOME_LIST',
  'hubungan penerima benefit': 'SET_BENEFIT_RELATION_LIST',
  'sumber iuran': 'SET_SOURCE_FUND_LIST',
  'jenis iuran': 'SET_CONTRIBUTION_TYPE_LIST',
  'jenis pembayaran': 'SET_PAYMENT_METHOD_PROGRAM_LIST',
  'cara pembayaran iuran': 'SET_FREQUENCY_PAYMENT_LIST',
  'periode pembayaran': 'SET_PERIOD_PAYMENT_LIST',
  'periode pembayaran bulanan': 'SET_PERIOD_PAYMENT_LIST',
  'periode pembayaran tahunan': 'SET_PERIOD_PAYMENT_LIST',
  'sumber dana perusahaan': 'SET_SOURCE_FUND_COMPANY_LIST',
  'asset': 'SET_ASSET_COMPANY_LIST',
  'dasar perhitungan pengelolaan investasi': 'SET_BASIC_CALCULATION_MANAGEMENT_INVESTMENT_LIST',
  'pilihan jenis klaim': 'SET_CLAIM_TYPE_LIST',
  'hubungan pemohon klaim': 'SET_RELATION_APPLICATION_CLAIM_LIST',
  'jenis pencairan dana': 'SET_DISBURSEMENT_CATEGORY_LIST',
  'pencairan anuitas': 'SET_DISBURSEMENT_ANUITAS_LIST',
  'level jabatan': 'SET_EMPLOYEE_POSITION_LIST',
  'penanganan selisih': 'SET_DIFFRENT_HANDLING_LIST'
}

const actions = {
  async getGroupedSourceScopeDetails(context, payload) {
    try {
      const scopeNames = Array.isArray(payload) ? payload : payload.scopeNames
      const filterActive = !Array.isArray(payload) && payload.filterActive
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL_GROUPED, {
        source_scope_names: scopeNames.join(',')
      })
      const grouped = response?.data?.data
      if (grouped) {
        for (const [scopeName, items] of Object.entries(grouped)) {
          const mutation = SOURCE_SCOPE_NAME_TO_MUTATION[scopeName]
          if (mutation) {
            const data = filterActive
              ? (items || []).filter(item => item?.status?.name === 'active')
              : items
            if (mutation === 'SET_CLAIM_TYPE_LIST') {
              context.commit(mutation, { isLoading: false, data })
            } else {
              context.commit(mutation, { data })
            }
          }
        }
      }
    } catch (err) {
      return err
    }
  },
  async getCorporateLegalList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_CORPORATE_LEGAL_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getInvestmentTypeList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_INVESTMENT_TYPE_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getServiceTypeList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_SERVICE_TYPE_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getStatusMartialList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_STATUS_MARTIAL_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getNationalEntityList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_NATIONAL_ENTITY_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getSourceIncomeList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_SOURCE_INCOME_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getBenefitRelationList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_BENEFIT_RELATION_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getSourceFundList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_SOURCE_FUND_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getContributionTypeList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_CONTRIBUTION_TYPE_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getPaymentMethodProgramList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_PAYMENT_METHOD_PROGRAM_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getFrequencyPaymentList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_FREQUENCY_PAYMENT_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getPeriodPaymentList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_PERIOD_PAYMENT_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getInvestmentAllocationList(context, payload) {
    try {
      const response = await apiGetAuth(API_CORE.INVESTMENT_ALLOCATION_LIST, payload)
      context.commit('SET_INVESTMENT_ALLOCATION_LIST', response?.data)
    } catch (err) {
      return err
    }
  },
  async getSourceFundCompanyList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_SOURCE_FUND_COMPANY_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getAssetCompanyList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_ASSET_COMPANY_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getBasicCalculationInvesmentList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_BASIC_CALCULATION_MANAGEMENT_INVESTMENT_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getClaimTypeList(context, payload) {
    context.commit('SET_CLAIM_TYPE_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_CLAIM_TYPE_LIST', {
        isLoading: false,
        data: response?.data?.data
      })
    } catch (err) {
      context.commit('SET_CLAIM_TYPE_LIST', {
        isLoading: false,
        data: []
      })
      return err
    }
  },
  async getRelationApplicationClaimList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_RELATION_APPLICATION_CLAIM_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getDisbursementCategoryList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_DISBURSEMENT_CATEGORY_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getDisbursementAnuitasList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_DISBURSEMENT_ANUITAS_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getEmployeePositionList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_EMPLOYEE_POSITION_LIST', response.data)
    } catch (err) {
      return err
    }
  },
  async getDiffrentHandlingList(context, payload) {
    try {
      const response = await apiGetAuth(API_SOURCE_SCOPE.SOURCE_SCOPE_DETAIL, payload)
      context.commit('SET_DIFFRENT_HANDLING_LIST', response.data)
    } catch (err) {
      return err
    }
  }
}

const getters = {
  get_corporate_legal_list: state => {
    return state.corporate_legal_list
  },
  get_investment_type_list: state => {
    return state.investment_type_list
  },
  get_service_type_list: state => {
    return state.service_type_list
  },
  get_status_martial_list: state => {
    return state.status_martial_list
  },
  get_national_entity_list: state => {
    return state.national_entity_list
  },
  get_source_income_list: state => {
    return state.source_income_list
  },
  get_benefit_relation_list: state => {
    return state.benefit_relation_list
  },
  get_source_fund_list: state => {
    return state.source_fund_list
  },
  get_contribution_type_list: state => {
    return state.contribution_type_list
  },
  get_payment_method_program_list: state => {
    return state.payment_method_program_list
  },
  get_frequency_payment_list: state => {
    return state.frequency_payment_list
  },
  get_period_payment_list: state => {
    return state.period_payment_list
  },
  get_investment_allocation_list: state => {
    return state.investment_allocation_list
  },
  get_source_fund_company_list: state => {
    return state.source_fund_company_list
  },
  get_asset_company_list: state => {
    return state.asset_company_list
  },
  get_basic_calculation_management_investment_list: state => {
    return state.basic_calculation_management_investment_list
  },
  get_claim_type_list: state => {
    return state.claim_type_list
  },
  get_relation_application_claim_list: state => {
    return state.relation_application_claim_list
  },
  get_disbursement_category_list: state => {
    return state.disbursement_category_list
  },
  get_disbursement_anuitas_list: state => {
    return state.disbursement_anuitas_list
  },
  get_employee_position_list: state => {
    return state.employee_position_list
  },
  get_diffrent_handling_list: state => {
    return state.diffrent_handling_list
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
